import { useStore } from "../lib/store";

export function Toasts() {
  const toasts = useStore((s) => s.toasts);
  const dismiss = useStore((s) => s.dismissToast);
  return (
    <div className="fixed top-2 inset-x-2 z-50 flex flex-col items-center gap-2 pointer-events-none" aria-live="polite">
      {toasts.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => dismiss(t.id)}
          className={`pointer-events-auto max-w-md rounded-lg px-4 py-2 text-sm shadow-lg border text-left ${
            t.kind === "error"
              ? "bg-danger text-white border-transparent"
              : t.kind === "success"
                ? "bg-ok text-white border-transparent"
                : "bg-surface text-ink border-line"
          }`}
        >
          {t.text}
        </button>
      ))}
    </div>
  );
}
